export const CLIPBOARD_ERRORS = {
  UNSUPPORTED: 'CLIPBOARD_UNSUPPORTED',
  DENIED: 'CLIPBOARD_DENIED',
  EMPTY: 'CLIPBOARD_EMPTY',
};

const isSupported = () => Boolean(navigator.clipboard?.readText);

export const readClipboardText = async () => {
  if (!isSupported()) {
    throw new Error(CLIPBOARD_ERRORS.UNSUPPORTED);
  }

  let text;
  try {
    text = await navigator.clipboard.readText();
  } catch {
    throw new Error(CLIPBOARD_ERRORS.DENIED);
  }

  const trimmed = text?.trim() ?? '';
  if (!trimmed) {
    throw new Error(CLIPBOARD_ERRORS.EMPTY);
  }

  return trimmed;
};
